export const getArrSeparatedByAsterisk = (str) => {
  if (str.includes("*")) {
    return str.split("*");
  }
  return [str];
};
